import { Box } from "@mui/material";
import { useAppSelector } from "../../../../../app/hooks";
import { formatAmount, formatHours } from "./helpers";
import { AggregatedExpense } from "./PayrollList";

type Props = {
  expense: AggregatedExpense;
};

export const ExpenseRow = ({ expense }: Props) => {
  const { translatedExpenseTypes } = useAppSelector((state: any) => ({
    translatedExpenseTypes: state.localized.expenseType,
  }));

  const { amount, unit, unitCost, total, expenseTypeCode } = expense;
  const amountAndUnit =
    unitCost === null ? null : `${formatAmount(unitCost)} €/${unit}`;

  return (
    <Box>
      <Box sx={{ fontWeight: 600 }}>
        {translatedExpenseTypes[expenseTypeCode] || expenseTypeCode}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Box>{`${unit === "h" ? formatHours(amount.toString()) : formatAmount(amount.toString())} ${unit}`}</Box>
        <Box
          sx={{
            fontWeight: 600,
            marginLeft: "5px",
            marginRight: "5px",
          }}
        >
          {" "}
          {"·"}{" "}
        </Box>
        {amountAndUnit ? <Box>{amountAndUnit}</Box> : null}
        <Box
          sx={{ marginLeft: "auto" }}
        >{`${formatAmount(total.toString())} €`}</Box>
      </Box>
    </Box>
  );
};
